import initMK from './_core/init.js';
import defineProp from './_core/defineprop.js';
import checkObjectType from './_helpers/checkobjecttype.js';
import forEach from './_helpers/foreach.js';
import set from './set.js';
import matreshkaError from './_helpers/matreshkaerror.js';
import forOwn from './_helpers/forown.js';
// creates property mediator
function createMediator(_ref) {
  var object = _ref.object,
    propDef = _ref.propDef,
    key = _ref.key,
    mediator = _ref.mediator;
  return function propMediator(value) {
    // args: value, previousValue, key, object itself
    return mediator.call(object, value, propDef.value, key, object);
  };
}
export default function mediate(object, givenKeys, mediator) {
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    mediator = givenKeys;
    givenKeys = object;
    object = this;
  } else {
    // throw error when object type is wrong
    checkObjectType(object, 'mediate');
  }
  var isKeysArray = Array.isArray(givenKeys);
  // allow to use key-mediator object as another method variation
  if (typeof givenKeys === 'object' && !isKeysArray) {
    forOwn(givenKeys, function (objVal, objKey) {
      return mediate(object, objKey, objVal);
    });
    return object;
  }
  initMK(object);
  // allow to use both single key and an array of keys
  var keys = isKeysArray ? givenKeys : [givenKeys];
  forEach(keys, function (key) {
    // if non-string is passed as a key
    if (typeof key !== 'string') {
      throw matreshkaError('mediate:key_type', {
        key: key
      });
    }
    var propDef = defineProp(object, key);
    var propMediator = createMediator({
      object: object,
      propDef: propDef,
      key: key,
      mediator: mediator
    });
    propDef.mediator = propMediator;
    // set new value
    set(object, key, propMediator(propDef.value), {
      fromMediator: true
    });
  });
  return object;
}